import { CSSProperties, FC, ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Spacer from "@src/lib/ui/Spacer";
import Text from "@src/lib/ui/Text";
import LockOutlineIcon from "@src/lib/icons/18px/lock-outline";

type Props = {
  showBanner: boolean;
  text: string;
  backgroundColor?: CSSProperties["backgroundColor"];
  color?: CSSProperties["color"];
  icon?: ReactNode;
  button?: React.ReactElement;
  borderRadius?: CSSProperties["borderRadius"];
};

const AnimatedBanner: FC<Props> = (props) => {
  return (
    <AnimatePresence>
      <motion.div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "stretch",
          position: "relative",
          overflow: "hidden",
        }}
        animate={props.showBanner ? "showBanner" : "hideBanner"}
        initial={"hideBanner"}
        variants={{
          showBanner: {
            height: 54,
            opacity: 1,
            transition: {
              delay: 0,
              duration: 0.3,
            },
          },
          hideBanner: {
            height: 0,
            opacity: 0,
            transition: {
              delay: 0,
              duration: 0.3,
            },
          },
        }}
      >
        <div
          className="flex flex-1 items-center justify-center self-stretch"
          style={{
            borderRadius: props.borderRadius ?? 16,
            backgroundColor: props.backgroundColor || "var(--blue-2)",
          }}
        >
          <div className="flex flex-1 items-center justify-center self-stretch">
            <span
              className="flex size-5 items-center justify-center"
              style={{ color: props.color || "var(--blue-9)" }}
            >
              {props.icon || <LockOutlineIcon className="size-4" />}
            </span>
            <Spacer size={8} axis={"horizontal"} />
            <Text
              variant="compact-title"
              color={props.color || "var(--blue-9)"}
            >
              {props.text}
            </Text>
            {props.button && <div className="ml-2 flex">{props.button}</div>}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedBanner;
